module.exports = __webpack_public_path__ + "static/media/om.7332c94c.svg";